// Identité de l'éditeur : source unique, lue par les pieds de page (application,
// landing, réservation, portail client) ET par les pages légales (mentions
// légales, confidentialité, CGU). Ne jamais réécrire ces informations en dur
// ailleurs.
import CGU_JSON from "./cgu.json";

export const PUBLISHER_NAME = "EnovaStudio";
export const PUBLISHER_LEGAL_FORM = "SAS";
export const PUBLISHER_CAPITAL = "1 000 €";
export const PUBLISHER_SIREN = "131 458 580";
export const PUBLISHER_RCS = "RCS Paris 131 458 580";
export const PUBLISHER_ADDRESS = "6 rue de Lota, 75116 Paris, France";
export const PUBLISHER_PRESIDENT = "Catherine Renard";
// Téléphone : laissé vide tant qu'il n'est pas connu — la ligne n'est alors
// pas affichée.
export const PUBLISHER_PHONE = "";
// TVA intracommunautaire : à confirmer avant tout affichage.
export const PUBLISHER_VAT_NUMBER = "FR39131458580";

export const CONTACT_EMAIL = "support@execpro360.com";

export const HOST = {
  name: "Hetzner Online GmbH",
  address: "Industriestr. 25, 91710 Gunzenhausen, Allemagne",
  phone: "+49 9831 505-0",
  website: "https://www.hetzner.com",
  websiteLabel: "www.hetzner.com",
};

export const PUBLISHER_LABEL = `${PUBLISHER_NAME} ${PUBLISHER_LEGAL_FORM}`;

// Version des CGU : contenu dans cgu.json (lisible par le serveur CommonJS,
// qui enregistre cette version à l'inscription dans users.cgu_version).
export const CGU_VERSION = CGU_JSON.version;
export const CGU_DATE = CGU_JSON.date;

export const COPYRIGHT_YEAR = 2026;
